import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import * as absencesActions from 'actions/Absences';
import { showErrorNotification, updateQuery } from 'actions/App';

import * as absencesApi from 'api/Absences';

import { ABSENCES_ALL_CAMPUSES, ABSENCES_FILTERS } from 'constants/Values';
import {
  GET_CAMPUSES_AND_ABSENCES_PENDING,
  GET_ACTIVE_ABSENCES_PENDING,
} from 'constants/ActionTypes';

function* getCampusesAndAbsences({ payload }) {
  try {
    const campuses = yield call(absencesApi.getCampuses);

    const absencesAllCampuses = {
      id: ABSENCES_ALL_CAMPUSES.ID,
      extName: ABSENCES_ALL_CAMPUSES.EXT_NAME,
    };

    campuses.data.unshift(absencesAllCampuses);

    yield put(absencesActions.getCampusesForAbsencesSuccess(campuses.data));
    yield put(
      absencesActions.getActiveAbsencesPending(payload.query, payload.params, payload.affectQuery),
    );
  } catch (error) {
    yield put(showErrorNotification(error.messages));
    yield put(absencesActions.getCampusesAndAbsencesFail());
  }
}

function* getAbsences({ payload }) {
  try {
    const { data } = yield call(absencesApi.getActiveAbsences, payload.query);

    if (payload.affectQuery) {
      yield put(updateQuery(payload.query.pagination, ABSENCES_FILTERS, payload.params));
    }

    yield put(absencesActions.getActiveAbsencesSuccess(data.entities, data.pageCount));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
    yield put(absencesActions.getActiveAbsencesFail());
  }
}

export function* getActiveCampusesAndAbsences() {
  yield takeLatest(GET_CAMPUSES_AND_ABSENCES_PENDING, getCampusesAndAbsences);
}

export function* getActiveAbsences() {
  yield takeLatest(GET_ACTIVE_ABSENCES_PENDING, getAbsences);
}

export default function* rootSaga() {
  yield all([fork(getActiveCampusesAndAbsences)]);
  yield all([fork(getActiveAbsences)]);
}
